import { callAPI } from "./api";

export const getLicensePlatesToExclude = async () => {
    let route = 'excludedLicensePlates';
    try {
        const data = await callAPI(route);
        return data;
    } catch (error) {
        throw error;
    }
};